import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material/styles';

interface GameCardMenuProps {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onEdit?: () => void;
  onDelete: () => void;
}

const GameCardMenu = ({
  anchorEl,
  onClose,
  onEdit,
  onDelete,
}: GameCardMenuProps) => {
  const theme = useTheme();

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          background: theme.custom.background1,
          mt: 1,
          boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
          minWidth: '120px',
          '& .MuiMenuItem-root': {
            px: 2,
            py: 1,
            fontSize: '14px',
            color: theme.custom.text,
            '&:hover': {
              backgroundColor: theme.custom.background3,
            },
          },
        },
      }}
    >
      <MenuItem onClick={onEdit}>Edit</MenuItem>
      <MenuItem
        onClick={onDelete}
        sx={{
          color: '#FF3B30 !important',
          '&:hover': {
            backgroundColor: `${theme.custom.background3} !important`,
          },
        }}
      >
        Delete
      </MenuItem>
    </Menu>
  );
};

export default GameCardMenu;
